"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const icon_new_1 = __importDefault(require("../icon-new"));
const { Plus, Bin, Edit, Cancel, ChevronRight, ChevronLeft } = icon_new_1.default;
const Button = styled_components_1.default.button `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border: 1px solid transparent;
  background-color: transparent;
  border-radius: 50px;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
  background-color: ${({ disabled, theme }) => disabled ? theme.neutral.lighter : "transparent"};
  transition: background-color 0.15s ease-in-out;

  &:hover,
  &:active {
    background-color: ${({ theme }) => theme.neutral.lighter};
  }
`;
const getIcon = (icon) => {
    switch (icon) {
        case "add":
            return react_1.default.createElement(Plus, null);
        case "edit":
            return react_1.default.createElement(Edit, null);
        case "delete":
            return react_1.default.createElement(Bin, null);
        case "close":
            return react_1.default.createElement(Cancel, null);
        case "arrowLeft":
            return react_1.default.createElement(ChevronLeft, null);
        case "arrowRight":
            return react_1.default.createElement(ChevronRight, null);
        default:
            throw new Error("Icon not supported");
    }
};
const RotaButtonIcon = (_a) => {
    var { onClick, icon = "delete", disabled = false, children } = _a, props = __rest(_a, ["onClick", "icon", "disabled", "children"]);
    return (react_1.default.createElement(Button, Object.assign({ onClick: onClick, disabled: disabled }, props), children || getIcon(icon)));
};
exports.default = RotaButtonIcon;
